module.exports = __webpack_public_path__ + "static/img/1.2-1.15b52e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/1.2-1.png
// module id = ZzrC
// module chunks = 1